import { Accordion, AccordionDetails, ListItem, Paper, List, AccordionSummary, Backdrop, Box, Button, CircularProgress, Divider, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
  } from "@dnd-kit/core";
  import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
    useSortable,
  } from "@dnd-kit/sortable";
  import ContentCopyIcon from '@mui/icons-material/ContentCopy';
  import previewCourseDefaultImage from "../../asset/images/preview-course-default.jpeg";
  import AddIcon from "@mui/icons-material/Add";  
import onboardingService, { createSection, getAllSections, removeSection, reorderSection } from "../../services/onboardingService/onboardingService";
import { useNavigate } from "react-router-dom";
import AlertSnackbar from "../../components/AlertSnackbar";
import { CSS } from "@dnd-kit/utilities";
import ReactPlayer from "react-player";
import LinkIcon from '@mui/icons-material/Link';
const OnboardingSettingsPage=()=>{
  const [isLoading, setIsLoading]= useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" }); 
  const [sectionData,setSectionData]= useState([]);
  const navigate = useNavigate();
    const [expanded, setExpanded] = useState('panel1');
    
    useEffect(()=>{
      fetchAllSections();
    },[])
    const fetchAllSections = async()=>{
      try{
      setIsLoading(true);

        const resp = await getAllSections();
        console.log(resp);
        if(resp.data.data)
          setSectionData(resp.data.data)
      }
      catch(error){
        setSnackbar({
          open: true,
          message: error.response.data.message || "Something Went Wrong",
          severity: "error",
        })
      }
      setIsLoading(false);

    }
  const handleChange =
  (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };


  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = sectionData.findIndex(
        (item) => item.sectionId.toString() === active.id
      );
      const newIndex = sectionData.findIndex(
        (item) => item.sectionId.toString() === over.id
      );
      const updatedItems = arrayMove(sectionData, oldIndex, newIndex).map((item, index) => ({
        ...item,
        order: index + 1,
      }));
  
      // Generate payload for reorder API
      const payload = updatedItems.map((item) => ({
        sectionId: item.sectionId,
        order: item.order,
      }));
  
      try {
        setIsLoading(true);
        await reorderSection({ newSections: payload });
        setSectionData(updatedItems);
        setSnackbar({
          open: true,
          message: "Sections reordered successfully",
          severity: "success",
        });
      } catch (err) {
        console.log(err);
        setSnackbar({
          open: true,
          message: err.response.data.message || "Something Went Wrong",
          severity: "error",
        });
      }
      setIsLoading(false);
    }
  };
  const handleEdit=(data)=>{

    navigate('/update_section',{state:data})
  }
  const handleClone=async(data)=>{
    try{
      setIsLoading(true);
      const payload = {...data, title: `Copy Of ${data.title}`};
      await createSection(payload);
      setSnackbar({
        open: true,
        message: "Section cloned successfully",
        severity: "success",
      });
      await fetchAllSections();
    }
    catch(err){
      setSnackbar({
        open: true,
        message: err.response.data.message || "Something Went Wrong",
        severity: "error",
      })
    }
    setIsLoading(false);
  }
  const handleDelete=async(data)=>{
    try{
      setIsLoading(true);
      await removeSection(data.sectionId)
      setSnackbar({
        open: true,
        message: "Section deleted successfully",
        severity: "success",
      });
      await fetchAllSections();
    }
    catch(err){
      setSnackbar({
        open: true,
        message: err.response.data.message || "Something Went Wrong",
        severity: "error",
      })
    }
    setIsLoading(false);
  }
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  const handleCopyLink = (section) => {
    let sectionLink = '';
    if(window.location.origin.includes("localhost")){
      sectionLink = `http://localhost:3000`
    } else if(window.location.origin.includes("test.yunapro")){
      sectionLink = `https://test.yunapro.com`
    } else {
      sectionLink = `https://app.yunapro.com`
    }
    sectionLink += `/home?selectedAccordion=${section.sectionId}`;
    navigator.clipboard.writeText(sectionLink);
    setSnackbar({
      open: true,
      message: "link copied to clipboard",
      severity: "success",
    });
  };
  const SortableItem = ({ section }) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id: section.sectionId.toString() });
    const style = {
      transform: CSS.Transform?.toString(transform),
      transition,
    };
  
  
    return (
      <ListItem
        ref={setNodeRef}
        style={style}
        {...attributes}
        sx={{
          paddingTop: "4px",
          paddingBottom: "4px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box {...listeners} sx={{ cursor: "move", marginRight: 2 }}>
          <DragIndicatorIcon />
        </Box>
        {/* <Box sx={{ minWidth: "40px", textAlign: "center" }}>
          {`#${section.order}`}
        </Box> */}
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Accordion
       sx={{
        "&::before": { display: "none" },
        boxShadow:"none",
        borderRadius:"10px",
        "& .MuiAccordionSummary-root": {
          borderRadius: expanded === section.sectionId?"10px 10px 0px 0px":"10px",
          backgroundColor: expanded === section.sectionId ? section.openTitleBackgroundColor : section.closeTitleBackgroundColor,
          borderTop: expanded === section.sectionId ? `3px  solid ${section.openTitleOutlineColor}` : `3px solid ${section.closeTitleOutlineColor}`,
          borderLeft: expanded === section.sectionId ? `3px  solid ${section.openTitleOutlineColor}` : `3px solid ${section.closeTitleOutlineColor}`,
          borderRight: expanded === section.sectionId ? `3px  solid ${section.openTitleOutlineColor}` : `3px solid ${section.closeTitleOutlineColor}`,
          borderBottom: expanded === section.sectionId ? `0px` : `3px solid ${section.closeTitleOutlineColor}`,

          color: expanded === section.sectionId ? section.openTitleTextColor : section.closeTitleTextColor,
        },
        "& .MuiAccordionDetails-root": {
          borderRadius:'0px 0px 10px 10px',
          border: expanded === section.sectionId ? `3px solid ${section.openLessonOutlineColor}` : "none",
        },
        "& .MuiAccordionSummary-content": {
          margin: "12px 0px" ,
        },
        width: "100%",
      }}
       key={section.sectionId} expanded={expanded === section.sectionId} onChange={handleChange(section.sectionId)} className="flex flex-col">
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Box sx={{width:"100%"}} ><Typography variant="h6" className="text-center" sx={{fontSize:"1.5rem",fontWeight:"600"}}>{section.title }</Typography> </Box>
          <Box ml="auto" display="flex" gap={1}>
          <IconButton aria-label="delete" onClick={(e)=>{e.stopPropagation();handleClone(section)}}>
            <ContentCopyIcon/>
          </IconButton>
          <IconButton aria-label="edit" onClick={(e)=>{e.stopPropagation();handleEdit(section)}}>
            <EditIcon />
          </IconButton>
          <IconButton aria-label="delete" onClick={(e)=>{e.stopPropagation();handleDelete(section)}}>
            <DeleteIcon />
          </IconButton>
          <IconButton aria-label="copyLink" onClick={(e)=>{e.stopPropagation();handleCopyLink(section)}}>
            <LinkIcon />
          </IconButton>
        </Box>
        </AccordionSummary>
        <AccordionDetails>
            <Box sx={{display:"flex", flexDirection:"column", width:"50%", margin:"auto", justifyContent: "center", alignItems:"center" ,gap:2, paddingTop:"22px"}} >
                <ReactPlayer
                  url={section.videoUrl}
                  width="600px"
                  height="300px"
                  controls
                  muted={false}
                  playing={false}
                  volume={0}
                />
              <Box sx={{width:"600px"}}>
                <Typography sx={{ "& ul":{listStyle:"disc",marginLeft:"18px"}, "& ol":{listStyle:"decimal",marginLeft:"18px"} , "& a":{color:"#4CA154",textDecoration:"underline"}}}>
                  <div dangerouslySetInnerHTML={{ __html: section.content }} />
                </Typography>
              </Box>
            </Box>
        </AccordionDetails>
      </Accordion>
        </Box>
      </ListItem>
    );
  };

    return (<div style={{ height: "90vh"}}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h1" sx={{ flexGrow: 1 }}>
          Onboarding Settings
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/create_section")}
          sx={{ ml: 2 }}
        >
          Create Section
        </Button>
      </Box>
      <Divider sx={{ marginBottom: "1em" }} />

      <Box sx={{ margin: "auto", marginBottom: "1em" }}>
        <Paper variant="outlined" sx={{ borderRadius: "8px" }}>
          <Box sx={{ padding: "0.8rem 1.2rem" }}>
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={sectionData?.map((section) => section.sectionId.toString())}
                strategy={verticalListSortingStrategy}
              >
                <List sx={{ padding: 0 }}>
                  {sectionData?.map((section) => (
                    <SortableItem key={section.sectionId} section={section} />
                  ))}
                </List>
              </SortableContext>
            </DndContext>
          </Box>
        </Paper>
      </Box>

      {isLoading && <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>}
        <AlertSnackbar
        open={snackbar.open}
        handleClose={handleCloseSnackbar}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </div>)
}
export default OnboardingSettingsPage;